import React from 'react';

const ExclamationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <rect x="8.5" y="2" width="7" height="12" rx="3.5" />
    <circle cx="12" cy="19.5" r="3.5" />
  </svg>
);

export default ExclamationIcon;
